import React from 'react'

export const CEFRLevelInfo =
  'https://en.wikipedia.org/wiki/Common_European_Framework_of_Reference_for_Languages#Common_reference_levels'

const moreInfoLink = (
  <a onClick={(e) => e.stopPropagation()} href={CEFRLevelInfo} target='_blank' rel='noreferrer'>
    more info.
  </a>
)

export const languageLevelsTooltip = {
  A1: <p>Breakthrough. Can understand and use basic expressions for concrete needs. {moreInfoLink}</p>,
  A2: <p>Waystage. Can communicate in simple and routine tasks and describe basic aspects of life. {moreInfoLink}</p>,
  B1: (
    <p>
      Threshold. Can comprehend and express oneself in everyday situations and describe experiences and opinions.{' '}
      {moreInfoLink}
    </p>
  ),
  B2: (
    <p>
      Vantage. Can interact fluently on a variety of topics and produce detailed texts on various subjects.{' '}
      {moreInfoLink}
    </p>
  ),
  C1: (
    <p>
      Advanced. Can understand complex texts, express oneself fluently, and use language in social and professional
      contexts. {moreInfoLink}
    </p>
  ),
  C2: (
    <p>
      Mastery. Can understand and summarize complex information, express oneself accurately in intricate situations, and
      engage in advanced discussions. {moreInfoLink}
    </p>
  ),
  Native: <p>Native Speaker.</p>
}
